export default __webpack_public_path__ + "static/media/Prophet's Cache of Oblivion.522b9060.jpg";